import { useTopic_SetDefaultTopicMutation, UserType, ItemType } from "sprout-graphql";
import useCurrentUser from "@sprout/client-graphql/dist/useCurrentUser";
import generateRandomKey from "@sprout/client-lib/dist/generateRandomKey";
import { useCallback } from "react";
import { useSnackbar } from "sprout-ui-dom/dist/Snackbar";
function useSetDefaultTopic({ defaultTopicId  }) {
    const currentUser = useCurrentUser();
    const showSnackbar = useSnackbar();
    const userId = Number(currentUser === null || currentUser === void 0 ? void 0 : currentUser.id);
    const [setDefaultTopic] = useTopic_SetDefaultTopicMutation({
        variables: {
            userId,
            defaultTopicId
        },
        optimisticResponse: {
            updateUserById: {
                user: {
                    id: userId,
                    nodeId: String(currentUser === null || currentUser === void 0 ? void 0 : currentUser.nodeId),
                    active: true,
                    type: UserType.User,
                    defaultTopic: {
                        nodeId: generateRandomKey(),
                        id: defaultTopicId,
                        type: ItemType.Topic,
                        __typename: "Item"
                    },
                    __typename: "User"
                },
                __typename: "UpdateUserPayload"
            }
        }
    });
    return useCallback(()=>{
        setDefaultTopic().catch(()=>{
            showSnackbar.error();
        });
    }, [
        setDefaultTopic,
        showSnackbar
    ]);
}
export default useSetDefaultTopic;
